/**
 * Make html safe. Removes all tags/scripts and so on
 * @param unsafe
 */
export const escapeHtml = (unsafe: string) =>
  !unsafe ? unsafe : unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
